/*
 * @Descripttion: 
 * @Author: KevinYoung
 * @Date: 2020-09-27 09:58:27
 * @LastEditors: KevinYoung
 * @LastEditTime: 2020-09-27 10:37:25
 */
import React from 'react';
import ReactDOM from 'react-dom';
import App from './rtcConnect';
import './App.css'

ReactDOM.render(
  <App  roomid={"KJMian"} />,
  document.getElementById('root')
);
